// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import { documentsStyles } from "@rpsc/Overrides/Widgets/ProductDetails/ProductDetailsDocuments";
import IconMinus from "@rpsc/XDL/Icons/IconMinus";
import IconPlus from "@rpsc/XDL/Icons/IconPlus";
import { createLinkIconStyles, styledScrollbar } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

documentsStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 16px;
        @media print {
            display: none;
        }
    `,
};

documentsStyles.documents = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 12px;
        padding-bottom: 8px;
        ${styledScrollbar()}
        max-height: 285px;
    `,
};

documentsStyles.documentGridItem = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        &&& ${StyledButton} {
            align-items: flex-start;
            & > span:first-child {
                padding-top: 6px;
            }
        }
    `,
};

documentsStyles.title = {
    variant: "h4",
    css: css`
        margin: 0;
        width: 100%;
    `,
};

documentsStyles.documentLink = {
    mergeCss: true,
    typographyProps: {
        size: 16,
        css: css`
            &&& {
                line-height: 22px;
            }
        `,
    },
    css: css`
        text-wrap: wrap;
        align-items: center;
        ${wrapInContainerStyles}
        ${IconWrapper}, svg {
            width: 12px;
            height: 16px;
        }
    `,
};

documentsStyles.showMoreLink = {
    ...createLinkIconStyles(
        IconPlus,
        {},
        { lineHeight: "17px" },
        {
            size: 11,
            css: css`
                height: 13px;
            `,
        },
    ),
};
documentsStyles.showLessLink = {
    ...createLinkIconStyles(
        IconMinus,
        {},
        { lineHeight: "17px" },
        {
            size: 11,
            css: css`
                height: 13px;
            `,
        },
    ),
};
